/* PackagePanelComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./PackagePanelRenderer");
const _ = require("lodash");

const PackageSummary = require("../../../lib/PackageSummaryMixin");

class PackagePanelComponent extends PackageSummary(EventEmitter) {
    constructor(pkg) {
        super();
        this._renderer = new Renderer(this);

        this._registerListeners();

        this.setPackageSummary(pkg);
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._packageSummary = undefined;
            this._renderer = undefined;
            resolve();
        });
        this.emit("Shutdown");
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    launchEditor(options) {
        let editorState = _.merge({ id: this.id }, { resource: this.packageSummary }, options);
        let launchOpts = _.merge({ id: this.id, title: this.getName() });
        this.emit("LaunchEditor", editorState, "PackageEditor", launchOpts);
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = PackagePanelComponent;
